import Links from '@/shared/constants/navegacao';
import { Column, DataTable } from '@/shared/components/tables/DataTable';
import { Link } from 'react-router-dom';
import { ProcessoSeletivoService, ReadProcessoSeletivoDto } from './processo-seletivo.service';
import { toast } from 'react-toastify';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { useEffect, useState } from 'react';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import './index.css';

const processoSeletivoService = new ProcessoSeletivoService();

export default function ProcessoSeletivoIndexPage() {
  const { setActions } = useBreadcrumbActions();

  const [registros, setRegistros] = useState<[ReadProcessoSeletivoDto[], number]>();
  const tableState = useDataTableState('nome');

  const handleBuscar = () => {
    processoSeletivoService.findAll({
      skip: (tableState.currentPage - 1) * tableState.pageSize,
      take: tableState.pageSize,
    }).then((result) => {
      setRegistros(result);
    }).catch((res) => {
      toast.error(String(res) || '');
    });
  }

  useEffect(() => {
    handleBuscar();
  }, []);

  useEffect(() => {
    setActions({
      primary: {
        label: 'Cadastrar',
        href: Links.ProcessoSeletivo_Criar,
        onClick: () => { },
        variant: 'primary',
      },
      secondary: {
        label: 'Análises',
        href: Links.ProcessoSeletivo_Analises,
        onClick: () => { },
      },
    });
    return () => setActions({});
  }, [setActions]);

  const formatarData = (data: Date | string) => {
    if (!data) return '-';
    return new Date(data).toLocaleDateString('pt-BR');
  };

  const formatarStatus = (status: string) => {
    const statusMap: Record<string, string> = {
      'rascunho': 'Rascunho',
      'pronto_para_iniciar': 'Pronto para iniciar',
      'aberto': 'Aberto',
      'fechado': 'Fechado',
      'finalizado': 'Finalizado',
    };
    return statusMap[status] || status;
  };

  let colunas: Column<ReadProcessoSeletivoDto>[] = [
    { key: "nome", header: "Nome" },
    {
      key: "dataInicioInscricoes",
      header: "Início Inscrições",
      render: (row) => formatarData(row.dataInicioInscricoes),
    },
    {
      key: "dataFimInscricoes",
      header: "Fim Inscrições",
      render: (row) => formatarData(row.dataFimInscricoes),
    },
    {
      key: "status",
      header: "Status",
      render: (row) => formatarStatus(row.status),
    },
    {
      key: "cursos",
      header: "Cursos",
      render: (row) => row.cursos?.map(c => c.nome).join(', ') || '-',
    },
    {
      key: "vagas",
      header: "Total de Municípios",
      render: (row) => {
        if (!row.vagas || row.vagas.length === 0) return 0;

        // Agrupar municípios por curso e contar o total de municípios selecionados
        // O mesmo município em cursos diferentes deve ser contado separadamente
        const municipiosPorCurso = new Map<number, Set<string>>();

        row.vagas.forEach(vaga => {
          if (vaga && vaga.municipio && vaga.cursoId) {
            if (!municipiosPorCurso.has(vaga.cursoId)) {
              municipiosPorCurso.set(vaga.cursoId, new Set<string>());
            }
            // Adicionar município ao conjunto do curso (Set elimina duplicatas dentro do mesmo curso)
            municipiosPorCurso.get(vaga.cursoId)!.add(vaga.municipio);
          }
        });

        // Somar o total de municípios únicos de cada curso
        let totalMunicipios = 0;
        municipiosPorCurso.forEach((municipios) => {
          totalMunicipios += municipios.size;
        });

        return totalMunicipios;
      },
    },
    {
      key: "totalCandidatos",
      header: "Lista de Candidatos",
      render: (row) => (
        <Link
          className="link-primary"
          to={`/candidato/processo-seletivo/${row.id}`}
          style={{ textDecoration: 'none', fontWeight: 'bold' }}
        >
          Ver Lista ({row.totalCandidatos || 0})
        </Link>
      ),
    },
    {
      key: "acoes",
      header: "Ações",
      render: (row) =>
        <Link className="link-secondary" to={Links.ProcessoSeletivo_Editar + '/' + row.id}>
          Editar
        </Link>
    },
  ];

  return (
    <div className="row">
      <div className="col-12">
        <h3 className="pt-2">Processos seletivos</h3>
        <span className="blockquote-footer pb-4 text-end">
          Gerenciamento de processos seletivos de estagiários.
        </span>
      </div>
      <hr className="pb-4" />

      {registros &&
        <DataTable
          columns={colunas}
          data={registros[0]}
          initialSortKey='nome'
          onChange={handleBuscar}
          serverSide={true}
          states={tableState}
          totalRecords={registros[1]}
          getRowClassName={(row) => {
            if (row.status === 'aberto') {
              return 'processo-seletivo-aberto';
            }
            return '';
          }}
        />
      }
    </div>
  );
}

